document.addEventListener('change', (event) => {
  if (event.target.matches('[data-nm-sort]')) event.target.form.requestSubmit();
});
document.addEventListener('submit', (event) => {
  if (!event.target.matches('.nm-filters__form')) return;
  event.target.querySelectorAll('input[type="number"]').forEach((input) => { if (!input.value) input.disabled = true; });
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-nm-tone]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const target = new URL(link.href);
  const current = new URL(window.location.href);
  current.searchParams.forEach((value, key) => {
    if (key === 'sort_by' || key.startsWith('filter.') || key === 'preview_theme_id') target.searchParams.append(key, value);
  });
  link.href = target.href;
});
